var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',_vm._l((_vm.columns),function(column){return _c('td',[(column.key === 'inspectionType.name')?[_c('FilterInspectionType',{on:{"updateFilter":_vm.updateFilter}})]:_vm._e()],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }